<fieldset class="no-legend">
  <div class="column-100">
    <label class="required">Přidělení LV</label>
    <div class="input">
      <gmt-select [data]="inputData" field="user" [restangularService]="restangular" resource="users/list" [filter]="filter" [itemPipe]="usernamePipe" (changed)="updated()"></gmt-select>
    </div>
  </div>
</fieldset>
<help [helpId]="helpIds.PANEL_TITLES_RIGHTS" class="cm-help-page"></help>
